/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2025-10-14 15:46:26
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-11-18 16:27:35
 * @FilePath: \mall\src\utils\aMap\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import AMapLoader from '@amap/amap-jsapi-loader'

const securityJsCode =
  process.env.VUE_APP_AMAP_SECURITY_CODE

window._AMapSecurityConfig = {
  securityJsCode: securityJsCode
}

const aMapKey = process.env.VUE_APP_AMAP_KEY

// 初始化地图
const aMap = async () => {
  const initMap = await AMapLoader.load({
    key: aMapKey, // 申请好的Web端开发者Key，首次调用 load 时必填
    version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: [
      // 'AMap.Scale',
      'AMap.Geolocation',
      'AMap.CitySearch',
      'AMap.Geocoder',
      'AMap.convertFrom'
    ] //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
  })
  // console.log('初始化定位', initMap)
  return initMap
}

const location = async () => {
  const AMap = await aMap()
  const geolocation = new AMap.Geolocation({
    enableHighAccuracy: false, // 设置为false以提高定位速度
    timeout: 5000, // 增加超时时间到5秒
    convert: false,
    GeoLocationFirst: true, // 优先使用GPS定位
    maximumAge: 300000 // 增加位置缓存时间到5分钟
  })

  return geolocation
}

const SearchCity = async (cityName = '') => {
  const AMap = await aMap()
  const Geocoder = new AMap.Geocoder()

  return Geocoder
}

const getCityconvertFrom = async ({ lat, lng }) => {
  const Amap = await aMap()
  const convertFrom = new Amap.convertFrom(
    `${lng},${lat}`,
    (status, result) => {
      console.log(status, result)
      resolve(status, result)
    }
  )
  return convertFrom
}

const LocalCity = async () => {
  try {
    const Amap = await aMap()
    const citySearch = new Amap.CitySearch()
    return citySearch
  } catch (error) {
    console.error(error)
  }
}

export {
  aMap,
  location,
  SearchCity,
  getCityconvertFrom,
  LocalCity
}
